<script>
// import NavBar from '@components/nav-bar.vue'
import appConfig from "@/app.config";
import Header from '@/components/Header.vue'
import Footer from '@/components/footer.vue'
import LoadingScreen from '@/components/LoadingScreen.vue'
import Cookies from '@/components/Cookies'
import Dailogs from '@/components/Dailogs'
// import {
//   setDocumentDirectionPerLocale,
//   setDocumentTitle,
//   setDocumentLang,
// } from '../../utils/i18n/document'
// import { loadLocaleMessagesAsync } from '../../i18n'

export default {
  components: { Footer, Header, LoadingScreen, Cookies, Dailogs },
  props: {
    headerStyle: {
      type: String,
      default() {
        return ''
      },
    },
    showLoadingScreen: {
      type: Boolean
    },
    page: {
      type: String
    }
  },
  data: () => ({
    //isLoading: true,
    assetsPath: appConfig.assetsPath,
    myStyle:{
      height: 'auto',
    },
    childStyle: {
      filter: 0
    },
  }),
  created() {

  },
  methods: {
    // loadLocaleMessages(locale) {
    //   this.isLoading = true
    //   loadLocaleMessagesAsync(locale).then(() => {
    //     setDocumentLang(locale)
    //     setDocumentDirectionPerLocale(locale)
    //     setDocumentTitle(this.$t('app.title'))
    //     this.isLoading = false
    //   })
    // },
    bodyPosition(num, viewPoint) {

      if (viewPoint === 'in') {
        const clientHeight = this.$refs.childMainBlock.clientHeight;
        //const blur = num + 1;
        //this.childStyle.filter = 'blur('+blur+'px)';
        this.myStyle.height = clientHeight + 'px';
        this.childStyle.position = 'fixed';
        this.childStyle.bottom = '0';
      } else {
        this.myStyle.height = 'auto';
        this.childStyle.filter = '';
        this.childStyle.position = 'initial';
        this.childStyle.bottom = '0';
      }
    }
    
  },
}
</script>

<template>
  <div>
    <LoadingScreen :showLoadingScreen="showLoadingScreen" :page="page" />
    <!-- <div v-else> -->
    <Header :headerStyle="headerStyle" />
    <!-- <NavBar @localeChange="loadLocaleMessages" /> -->
    <!-- </div> -->
    <div class="w-100 d-inline-block p-rel" :style="myStyle" ref="childMainBlock">
      <div class="w-100 d-inline-block p-rel" :style="childStyle" id="parent-main-block">
        <slot />
      </div>
    </div>
    <Footer :bodyPosition="bodyPosition" :showLoadingScreen="showLoadingScreen" />

    <Cookies/>

    <Dailogs/>

  </div>
</template>

<style lang="scss" module>
@import "src/design/index.scss";

.container {
  width: 100%;
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}


</style>
